import '../../node_modules/@betha-plataforma/estrutura-componentes/dist/estrutura-componentes/estrutura-componentes.css';
import '../../node_modules/@mdi/font/css/materialdesignicons.css';
import '../../node_modules/@betha-plataforma/estrutura-componentes/dist/collection/assets/fonts.css';
import './styles/sys.scss';
